module.exports = __webpack_public_path__ + "img/data-quality-a-z-level-1.620fdda2.svg";